import { Box, Grid, TextField, InputAdornment } from "@mui/material";
import MasonryGrid from "../../components/MasonryGrid/MasonryGrid";
import {
  getCityStateFromTemple,
  getConcatenatedTempleNames,
  getOfferPriceFromV1,
  getOneImageForTemple,
  getTempleName,
} from "../../utils/HelperFunctions";
import { Search as Search } from "@mui/icons-material";
import BlogContent from "../../components/BlogContent/BlogContent";
import NoDataFound from "../../components/NoDataFound/NoDataFound";
import { useSelector } from "react-redux";
import "./PujaView.scss";
import { useTranslation } from "react-i18next";
import { LOCALIZATION } from "../../utils/localization";
import { LOCALSTORAGE_KEY, orderType } from "../../utils/Constants";
import TempleServiceListCard from "../../components/card/TempleServiceListCard/TempleServiceListCard";

function PujaView({
  allPujaList,
  onClickAddPuja,
  navigateToGlobalSearch,
  benefitsList,
}: any) {
  const { t } = useTranslation();
  const { isLoading } = useSelector((state: any) => state.puja);

  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";
    
  const priceConversionState = useSelector(
    (state: any) => state?.priceConversion,
  );

  const {
    rate = 1,
    currencySymbols = "₹",
    isOverseas = false,
  } = priceConversionState?.priceConversionRate || {};

  return (
    <Box className="pageContainer templePage">
      <Box className="templeBlock">
        <Grid container spacing={1}>
          <Grid item xs={12} md={2} className="templeLeftBlock">
            {/* <LeftAddressCard
              header={props.TDTexts.CURRENTADDRESS}
              address={
                props.userAddressList && props.userAddressList.length > 0
                  ? props.userAddressList[0].formatted_address
                  : ""
              }
              footerButton="Edit or add an address"
            /> */}
          </Grid>

          <Grid item xs={12} md={8}>
            {/* Search */}
            <TextField
              className="searchView"
              onFocus={navigateToGlobalSearch}
              variant="outlined"
              placeholder={t(LOCALIZATION.Search_for_pujas)}
              sx={{ "& fieldset": { border: "none" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ color: "#000" }} />
                  </InputAdornment>
                ),
              }}
            />
            <Box className="templeCenterBlock pujaBlock" data-scroll-id={"all-puja-list"}>
              {allPujaList && allPujaList?.length > 0 && (
                <MasonryGrid
                  items={allPujaList}
                  renderItem={(item: any, id: number) => {
                    const singleTempleName = item?.personalInfo
                      ? getTempleName(
                          { personalInfo: item?.personalInfo },
                          savedLanguage,
                        )
                      : "";
                    const packageTempleName = getConcatenatedTempleNames(
                      item?.templeList,
                    );
                    const templeName =
                      singleTempleName || packageTempleName || "";

                    const templeAddress = item?.personalInfo
                      ? getCityStateFromTemple(item?.personalInfo)
                      : "";

                    const templeCardImage =
                      item?.pujaBg?.uri ||
                      getOneImageForTemple(item?.personalInfo?.media?.pictures);
                    const updatedBenefitList =
                      item?.benefitList?.map((benefit: any) => {
                        const benefitDetails = benefitsList?.find(
                          (bnft: any) => bnft?.benefitId === benefit?.benefitId,
                        );
                        return benefitDetails
                          ? { ...benefit, ...benefitDetails }
                          : benefit;
                      }) || [];

                    const serviceBenefits = updatedBenefitList.map(
                      (benefit: any) => benefit?.name,
                    );
                    const basePrice = isOverseas
                      ? item?.overseasBasicPrice
                      : item?.indianBasicPrice;

                    const finalTotalPrice =
                      basePrice > 0
                        ? parseFloat((basePrice * rate)?.toFixed(2))
                        : 0;

                    const offerV1 =
                      item?.type === orderType?.pujaPackage
                        ? item?.priceBreakupV1
                        : item?.multiplePujaDetails?.length
                          ? item?.multiplePujaDetails[0]?.priceBreakupV1
                          : null;

                    const offerActualPrice = getOfferPriceFromV1(
                      offerV1,
                      isOverseas,
                      false,
                      rate,
                    );

                    const serviceTitle =
                      item?.type === orderType?.pujaPackage
                        ? item?.cardTitle || ""
                        : item?.pujaSpecialDesc || "";

                    return (
                      <TempleServiceListCard
                        key={`${item?.id}-${id}`}
                        templeData={{ pujaDetails: { ...item } }}
                        templeName={templeName}
                        templeAddress={templeAddress}
                        templeCardImage={templeCardImage}
                        overlayText={{
                          leftSideTextOverlay: item?.leftSideTextOverlay,
                          rightSideTextOverlay: item?.rightSideTextOverlay,
                        }}
                        overlayCss={item?.overlayCss ?? null}
                        serviceTitle={serviceTitle}
                        serviceDescription={item?.pujaName}
                        serviceBenefits={serviceBenefits}
                        serviceThithiName={item?.tithiName || ""}
                        finalTotalPrice={finalTotalPrice}
                        offerActualPrice={offerActualPrice}
                        currencySymbols={currencySymbols}
                        type={item?.type}
                        selectTemple={onClickAddPuja}
                        actionLabel={
                          item?.type === orderType?.pujaPackage
                            ? t(LOCALIZATION?.Book_Package)
                            : t(LOCALIZATION?.View_to_participate)
                        }
                      />
                    );
                  }}
                />
              )}

              {allPujaList.length === 0 && !isLoading && <NoDataFound />}
            </Box>
          </Grid>
          <Grid item xs={12} md={2} lg={2} xl={2} className="templeRightBlock">
            {/* <RightBlockCard /> */}
          </Grid>
        </Grid>
        <Box className="bottomBlogContent">
          <BlogContent />
        </Box>
      </Box>
    </Box>
  );
}

export default PujaView;
